import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubscriptionService from "@/services/api/subscription";

export interface FaqItem {
  id?: number;
  question: string;
  answer: string;
}

interface FaqState {
  faqs: FaqItem[];
  isLoading: boolean;
  error: string | null;
}

const initialState: FaqState = {
  faqs: [],
  isLoading: false,
  error: null,
};

export const fetchFaqs = createAsyncThunk(
  "faq/fetchFaqs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SubscriptionService.getFaqs();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to load FAQs");
    }
  },
);

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    clearFaqs: (state) => {
      state.faqs = [];
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.isLoading = false;
        // Handle nested response structure: { data: { results: [...] } }
        const results = action.payload?.data?.results || action.payload?.results || action.payload || [];
        state.faqs = Array.isArray(results) ? results : [];
        state.error = null;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearFaqs } = faqSlice.actions;
export default faqSlice.reducer;
